export default __webpack_public_path__ + "static/media/register.348780b6.jpg";